import { render, staticRenderFns } from "./SmsVerifyForm.vue?vue&type=template&id=75d71ec2&scoped=true&"
import script from "./SmsVerifyForm.vue?vue&type=script&lang=js&"
export * from "./SmsVerifyForm.vue?vue&type=script&lang=js&"
import style0 from "./SmsVerifyForm.vue?vue&type=style&index=0&id=75d71ec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d71ec2",
  null
  
)

export default component.exports